import type { BackToSchool2026Phase2Variant } from '~/features/promotions/constants/back-to-school-2026-phase-2-sale';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { backToSchool2026Phase2CampaignCore } from './campaign-core';
import { backToSchool2026Phase2CampaignSurfaces } from './surfaces';

export { BACK_TO_SCHOOL_2026_PHASE_2_CAMPAIGN_ID, backToSchool2026Phase2CampaignCore } from './campaign-core';

const backToSchool2026Phase2PromoCampaignTyped = {
  ...backToSchool2026Phase2CampaignCore,
  surfaces: backToSchool2026Phase2CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<BackToSchool2026Phase2Variant>;

export const backToSchool2026Phase2PromoCampaign = backToSchool2026Phase2PromoCampaignTyped as RegisteredPromoCampaign;
